import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

import type { SignalEventType } from "../../signals/types";

export const getSignalEventFilterTrackingLabel = (type: SignalEventType): string => {
    if (type === SignalType.RoleChanges) {
        return "signals filters/Role changes";
    }

    return `signals filters/${type}`;
};
